import { draftFormMap } from "./newJoineeDraftMap";

function isPlainObject(value) {
  return value !== null && typeof value === "object" && !Array.isArray(value);
}

function getMap(formType) {
  return draftFormMap[formType] || null;
}

export function pickSectionDraftData(formType, section, sectionState) {
  const map = getMap(formType);
  if (!map || !map[section]) return {};

  const { wrapperKey } = map[section];
  return { [wrapperKey]: sectionState };
}

export function applySectionDraftData(formType, section, currentState, draftData) {
  const map = getMap(formType);
  if (!map || !map[section] || !isPlainObject(draftData)) return currentState;

  const { wrapperKey } = map[section];
  // Accepts either the wrapped draft data or the stored section ({ data, savedAt }).
  const source =
    !(wrapperKey in draftData) && isPlainObject(draftData.data)
      ? draftData.data
      : draftData;
  const payload = source[wrapperKey];
  if (!isPlainObject(payload)) return currentState;

  return { ...currentState, ...payload };
}
